import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const validateEmail = email => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

/**
 * Validates phone number
 *
 * @param phoneNumToCheck
 * @return { boolean } - validity of phone number
 * @author jozef.repan
 */
export const validatePhoneNumber = phoneNumToCheck => {
  const phoneNumObject = parsePhoneNumberFromString(phoneNumToCheck);

  // unable to parse phone number
  if (phoneNumObject === undefined) return false;

  return phoneNumObject.isValid();
};

/**
 * Checkes if applications is loaded without tokens, if so, redirect to
 * base domain
 *
 * @author jozef.repan
 */
export const handleNoTokensRedirect = () => {

};
